import { MappingField } from 'src/containers/ProjectDiagram/types/data';
import { isMapping } from 'src/containers/ProjectDiagram/utils/data';
import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 * * on {@link MappingField} update `target` field from @type {(string | null)} to array of strings
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v4 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v4Projects(prevState.projects);
  }

  return nextState;
};

const v4Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    if (!project.diagram) {
      projectsById[projectId] = project;
      return;
    }

    const updatedLinkDataArray = project.diagram.model.linkDataArray.map(
      (linkData) => {
        if (isMapping(linkData)) {
          const { fields } = linkData;
          const newFields = Object.values(fields).reduce<
            Record<string, MappingField>
          >((acc, field) => {
            const newField: MappingField = {
              label: field.label,
              value: field.value,
              targets: [],
            };

            // @ts-ignore
            if (field.target) {
              // @ts-ignore
              newField.targets = [field.target];
            }

            acc[newField.value] = newField;
            return acc;
          }, {});
          return { ...linkData, fields: newFields };
        }
        return linkData;
      }
    );

    projectsById[projectId] = {
      ...project,
      diagram: {
        ...project.diagram,
        model: {
          ...project.diagram.model,
          linkDataArray: updatedLinkDataArray,
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
